module.exports = __webpack_public_path__ + "img/icon4.f8d15c99.png";